var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-footer"},[_c('span',[_vm._v("版权所有 ©"),_c('vxe-link',{attrs:{"href":"https://vxeui.com/","target":"_blank"}},[_vm._v("vxe")]),_vm._v(" 2018-"+_vm._s(_vm.dateStr))],1)])}
var staticRenderFns = []

export { render, staticRenderFns }